/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { entityReducer } from './reducers/index'
import { default as whitelist } from './reducers/whitelist'

export { whitelist }
export const entity = filterActions<
  ReturnType<typeof entityReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(entityReducer, whitelist)
